import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import {
  FormInput,
  Text,
  Modal,
  modalStyles,
  theme,
  type WrappedButtonProps,
  styles as baseStyles,
} from '@socrait/react';

import { Period } from '~/services/types';

type DeleteModalProps = {
  period: Period;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function DeleteModal({ period, isOpen, onClose, onConfirm }: DeleteModalProps) {
  const { name, shortName } = period ?? {};
  const [confirmation, setConfirmation] = useState('');

  const title = (
    <Text style={modalStyles.title}>
      Delete Class <Text style={modalStyles.title}>"{name}"</Text>?
    </Text>
  );

  const content = (
    <View style={styles.content}>
      <Text style={modalStyles.text}>To confirm deletion, type the period number "{shortName}" below.</Text>
      <FormInput
        value={confirmation}
        onChangeText={setConfirmation}
        label="Confirm deletion:"
        labelStyle={styles.label}
        containerStyle={styles.inputContainer}
      />
      <Text style={styles.warningContainer}>
        <Text style={[styles.warningText, baseStyles.boldText]}>Warning! </Text>
        <Text style={styles.warningText}>
          Deleting this class will also delete ALL VOICE NAMES and ASSOCIATED DATA.
        </Text>
      </Text>
    </View>
  );

  const buttons: WrappedButtonProps[] = [
    {
      name: 'Cancel',
      onPress: onClose,
    },
    {
      name: 'Delete',
      icon: 'delete',
      onPress: onConfirm,
      variant: 'negative',
      disabled: confirmation !== shortName,
    },
  ];

  return (
    <Modal
      title={title}
      content={content}
      buttons={buttons}
      modalVisible={isOpen}
      handleClose={onClose}
      buttonLayout="row"
      containerStyle={styles.container}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    maxWidth: 500,
  },
  content: {
    gap: theme.spacing.xlarge,
  },
  warningContainer: {
    backgroundColor: theme.colors.red,
    padding: theme.spacing.small,
    borderRadius: theme.borderRadius.small,
  },
  warningText: {
    color: theme.colors.white,
  },
  inputContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  label: {
    marginBottom: -theme.spacing.medium,
  },
});
